<template>
    <footer class="footer" v-if="sections && sections.length > 0">
        <div class="footer__content">
            <div class="footer__section" v-for="(section, index) in sections" :key="index">
                <h3 class="footer__title">{{ section.title }}</h3>
                <!-- <p v-if="section.text" class="footer__text footer__item">{{ section.text }}</p> -->
                <template v-for="(item, index) in section.children" :key="index" class="flex justify-between">
                    <div class="text-sm pb-2" v-if="item.type === 'feedback'">
                        <btn-wrapper type="a" class='footer__text footer__item cursor-pointer'
                                     @click.prevent="showFeedback"
                                     :label="showModal ? item.text : feedbackEmail"/>
                    </div>
                    <div class="text-sm pb-2 inline-flex mr-5" v-else-if="item.type === 'icon'">
                        <btn-wrapper type="a" :href="item.href" target='_blank'>
                            <img :src="item.icon" v-if="item.type === 'icon'" class="footer__icon" alt="Banner"/>
                        </btn-wrapper>

                    </div>
                    <div class="text-sm pb-2" v-else>
                        <btn-wrapper type="a" :href="item.href" class='footer__text footer__item'
                                     target='_blank'>
                            {{ item.text }}
                        </btn-wrapper>
                    </div>
                </template>
            </div>
        </div>
        <FeedbackForm v-if="showModal" ref="feedbackForm"></FeedbackForm>
    </footer>
</template>

<script>
import {computed, ref, watch} from 'vue'
import {useI18n} from 'vue-i18n'
import {useRoute} from 'vue-router'
import {useStore} from 'vuex'
import FeedbackForm from '@/components/UI/FeedbackForm/index.vue'
import BtnWrapper from '../BtnWrapper.vue'
import {useToast} from 'vue-toastification'


export default {
    name: 'Footer',
    components: {BtnWrapper, FeedbackForm},
    computed: {
        showModal() {
            return this.$store.getters.getCustomInformation.customBackendAddress
        },
        feedbackEmail() {
            return this.$store.getters.getCustomInformation.feedbackEmail
        }
    },
    methods: {
        showFeedback(event) {
            if (this.showModal) {
                this.feedbackForm.getFeedbackInfo()
            } else {
                const toast = useToast()
                navigator.clipboard.writeText(event.target.innerText)
                    .then(() => toast.info(this.$t('footer.copyToBuffer')))
                    .catch(err => console.error(this.$t('footer.errorCopyToBuffer'), err))
            }
            // To do: Sentry checks
        }
    },
    setup() {
        const feedbackForm = ref(null)
        const {t} = useI18n()
        const route = useRoute()
        const store = useStore()
        const courseSupportEmails = ref([])
        const courseInfo = ref({})
        const courseId = computed(() => route.params.courseId)
        let sections = []

        const getTeachers = function () {
            if (!courseId.value) return

            return store.dispatch('getCourseTeachers', courseId.value).then(({teacher, manager}) => {
                return Promise.resolve(teacher.slice(0, 2).map(el => ({text: el.email, href: `mailto:${el.email}`}))) // ** берем двух преподавателей, чтобы исключить раздувание футера при множестве преподавателей
            })
        }

        const getCourseSupportEmails = async () => {
            courseSupportEmails.value = []

            if (!courseId.value) return

            try {
                const result = await store.dispatch('getFullCourseInfo', {id: courseId.value})
                courseInfo.value = result?.courses[0]
                const email = courseInfo.value.customfields.find(el => el.shortname === 'supportemail')

                if (email?.value) {
                    courseSupportEmails.value = email.value.split(/,\s*/).map(el => ({
                        href: `mailto:${el}`,
                        text: el,
                        label: el
                    }))
                } else {
                    throw new Error(this.$t('footer.courseEmailNotSet'))
                }
            } catch (err) {
                // !!! запрос участников курса создает нагрузку !!! нужно выполнять только по требованию, не грузить по дефолту
                courseSupportEmails.value = await getTeachers()
            }
        }

        const loadFooterData = () => {
            try {
                sections = computed(() => store.getters.getCustomInformation?.footerData?.sections)
            } catch (err) {
                console.error('Failed to load footer info', err)
            }
        }

        getCourseSupportEmails()
        loadFooterData()

        watch(courseId, getCourseSupportEmails)

        return {
            feedbackForm,
            sections,
            t
        }
    }
}
</script>

<style lang="scss" scoped>
@import './scss/footer.scss';
</style>
